import React, { useState } from 'react';
import {
  BottomNavigation,
  BottomNavigationAction,
  Paper,
  Drawer,
  useMediaQuery,
  useTheme,
  Badge,
} from '@mui/material';
import {
  Category as CategoryIcon,
  ShoppingCart as CartIcon,
  ViewModule as ProductsIcon,
} from '@mui/icons-material';
import { useCart } from '../../hooks/useCart';
import CategoryList from '../Categories/CategoryList';
import { useNavigate, useLocation } from 'react-router-dom';

export const BottomNav: React.FC = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { items } = useCart();

  // Get the current value based on the route
  const getCurrentValue = () => {
    if (location.pathname === '/cart') return 2;
    if (drawerOpen) return 1;
    return 0;
  };

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    switch (newValue) {
      case 0: // Products
        navigate('/products');
        break;
      case 1: // Categories
        setDrawerOpen(true);
        break;
      case 2: // Cart
        navigate('/cart');
        break;
    }
  };

  if (!isMobile) return null;

  return (
    <>
      <Paper 
        sx={{ 
          position: 'fixed', 
          bottom: 0, 
          left: 0, 
          right: 0, 
          zIndex: theme.zIndex.appBar,
          borderTop: `1px solid ${theme.palette.divider}`,
        }} 
        elevation={3}
      >
        <BottomNavigation
          value={getCurrentValue()}
          onChange={handleChange}
          showLabels
        >
          <BottomNavigationAction 
            label="Products" 
            icon={<ProductsIcon />} 
          />
          <BottomNavigationAction 
            label="Categories" 
            icon={<CategoryIcon />} 
          />
          <BottomNavigationAction 
            label="Cart" 
            icon={
              <Badge 
                badgeContent={items.length} 
                color="error"
                sx={{
                  '& .MuiBadge-badge': {
                    right: -3,
                    top: 3,
                    border: `2px solid ${theme.palette.background.paper}`,
                    padding: '0 4px',
                  },
                }}
              >
                <CartIcon />
              </Badge>
            }
          />
        </BottomNavigation>
      </Paper>

      {/* Categories Drawer */}
      <Drawer
        anchor="left"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        PaperProps={{
          sx: {
            width: { xs: '65%', sm: 280 },
            maxWidth: '100%',
          },
        }}
      >
        <CategoryList 
          onCategorySelect={() => {
            setDrawerOpen(false);
          }} 
        />
      </Drawer>
    </>
  );
};
